"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "UsersController", {
    enumerable: true,
    get: function() {
        return UsersController;
    }
});
const _common = require("@nestjs/common");
const _config = require("@nestjs/config");
const _nocodbsdk = require("nocodb-sdk");
const _globalguard = require("~/guards/global/global.guard");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _usersservice = require("~/services/users/users.service");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let UsersController = class UsersController {
    async update(body, req, res) {
        res.json(await this.usersService.profileUpdate({
            id: req.user.id,
            params: body,
            req
        }));
    }
    constructor(usersService, appHooksService, config){
        this.usersService = usersService;
        this.appHooksService = appHooksService;
        this.config = config;
    }
};
_ts_decorate([
    (0, _common.Patch)([
        '/api/v1/user/profile',
        '/api/v2/meta/user/profile'
    ]),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    (0, _common.HttpCode)(200),
    _ts_param(0, (0, _common.Body)()),
    _ts_param(1, (0, _common.Request)()),
    _ts_param(2, (0, _common.Response)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        void 0,
        typeof _nocodbsdk.NcRequest === "undefined" ? Object : _nocodbsdk.NcRequest,
        void 0
    ]),
    _ts_metadata("design:returntype", Promise)
], UsersController.prototype, "update", null);
UsersController = _ts_decorate([
    (0, _common.Controller)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _usersservice.UsersService === "undefined" ? Object : _usersservice.UsersService,
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService,
        typeof _config.ConfigService === "undefined" ? Object : _config.ConfigService
    ])
], UsersController);
